import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import Tile from "./Tile";

class FundsTiles extends React.Component {
  state = {};

  render() {
    const { funds } = this.props.fund;
    return (
      <Fragment>
        <Grid container spacing={8}>
          {Object.keys(funds).map(id => (
            <Tile key={id} fund={funds[id]} />
          ))}
        </Grid>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ fund }) => ({ fund });

export default connect(
  mapStateToProps  
)(FundsTiles);
